class NutritionSlider extends HTMLElement {
  connectedCallback() {
    if (this.swiperInstance) return;

    const container = this.querySelector('.nutrition__swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const prevEl = this.querySelector('.nutrition__nav-btn--prev');
    const nextEl = this.querySelector('.nutrition__nav-btn--next');

    this.equalizeTitles = this.equalizeTitles.bind(this);
    this.updateNavVisibility = this.updateNavVisibility.bind(this);
    this.onResize = this.onResize.bind(this);
    this.syncLayout = this.syncLayout.bind(this);

    this.swiperInstance = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 8,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      roundLengths: true,
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        990: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      on: {
        init: () => this.syncLayout(),
        resize: () => this.syncLayout(),
        breakpoint: () => this.syncLayout(),
      },
    });

    window.addEventListener('resize', this.onResize);
  }

  syncLayout() {
    this.equalizeTitles();
    this.updateNavVisibility();
  }

  equalizeTitles() {
    const titles = this.querySelectorAll('.nutrition__card-title');
    if (!titles.length) return;

    titles.forEach((title) => {
      title.style.minHeight = '';
    });

    let maxHeight = 0;
    titles.forEach((title) => {
      maxHeight = Math.max(maxHeight, title.offsetHeight);
    });

    titles.forEach((title) => {
      title.style.minHeight = `${maxHeight}px`;
    });
  }

  updateNavVisibility() {
    const nav = this.querySelector('.nutrition__nav');
    if (!nav || !this.swiperInstance) return;

    const slidesCount = this.swiperInstance.slides.length;
    const perView = Number(this.swiperInstance.params.slidesPerView) || 1;
    const needsNav = slidesCount > perView;

    nav.hidden = !needsNav;
    nav.style.display = needsNav ? 'flex' : 'none';
  }

  onResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => this.syncLayout(), 100);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    window.clearTimeout(this.resizeTimer);

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

if (!customElements.get('nutrition-slider')) {
  customElements.define('nutrition-slider', NutritionSlider);
}

document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('nutrition-slider');
  if (slider && typeof slider.connectedCallback === 'function') {
    slider.connectedCallback();
  }
});
